//import "jquery";
import angular from "angular";
import uibPosition from "angular-ui-bootstrap/src/position/position";
import uibDropdown from "angular-ui-bootstrap/src/dropdown/dropdown";
import "./ui-dropdown";

function dcDropdown() {

  return {
    restrict: "EA",
    scope: {},
    //templateUrl : "modules/common/directives/portlet/portlet.tpl.html",
    link: function (scope, elem, attrs) {
      $(elem).dcDropDown();
    }
  };

}

export default angular.module("dc-ui.dc-dropdown",["ui.bootstrap.dropdown"])
  .directive("dcDropdown",dcDropdown)
  .name;



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-dropdown/dc-dropdown.js